export var AssetCategory;
(function (AssetCategory) {
    AssetCategory["CRYPTO"] = "CRYPTO";
    AssetCategory["ETF"] = "ETF";
    AssetCategory["COMMODITY"] = "COMMODITY";
    AssetCategory["RWA"] = "RWA";
})(AssetCategory || (AssetCategory = {}));
export var AssetProvider;
(function (AssetProvider) {
    AssetProvider["TANGANY"] = "TANGANY";
    AssetProvider["TRADEVEST"] = "TRADEVEST";
    AssetProvider["SELF_CUSTODY"] = "SELF_CUSTODY";
})(AssetProvider || (AssetProvider = {}));
export var ProviderCapability;
(function (ProviderCapability) {
    ProviderCapability["CUSTODY"] = "CUSTODY";
    ProviderCapability["TRADING"] = "TRADING";
    ProviderCapability["SEND_RECEIVE"] = "SEND_RECEIVE";
    ProviderCapability["PRICE_FEED"] = "PRICE_FEED";
})(ProviderCapability || (ProviderCapability = {}));
export var AssetPriceSource;
(function (AssetPriceSource) {
    AssetPriceSource["COINPAPRIKA"] = "COINPAPRIKA";
    AssetPriceSource["TRADEVEST"] = "TRADEVEST";
    AssetPriceSource["MANUAL"] = "MANUAL";
})(AssetPriceSource || (AssetPriceSource = {}));
//# sourceMappingURL=asset.types.js.map